import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import './Auth.css';

const API_URL = '';

function AcceptInvite() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');

  const [senha, setSenha] = useState('');
  const [confirmacao, setConfirmacao] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!token) {
      setError('Convite inválido. Solicite um novo convite ao administrador.');
    }
  }, [token]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!token) return;

    if (senha.length < 8) {
      setError('A senha deve ter no mínimo 8 caracteres.');
      return;
    }

    if (senha !== confirmacao) {
      setError('As senhas não conferem.');
      return;
    }

    setLoading(true);
    try {
      await axios.post(`${API_URL}/auth/accept-invite`, { token, senha });
      setSuccess(true);
      setTimeout(() => navigate('/login'), 2500);
    } catch (err) {
      const detail = err.response?.data?.detail;
      setError(detail || 'Erro ao aceitar convite. Tente novamente.');
    } finally {
      setLoading(false);
    }
  };

  if (success) {
    return (
      <div className="auth-container">
        <div className="auth-card">
          <div className="auth-header">
            <h1>CoreWood</h1>
            <h2>Conta ativada</h2>
          </div>
          <div className="auth-message auth-message-success">
            <p>Sua conta foi ativada. Redirecionando para o login...</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-header">
          <h1>CoreWood</h1>
          <h2>Bem-vindo!</h2>
          <p>Defina sua senha para ativar sua conta</p>
        </div>

        <form onSubmit={handleSubmit} className="auth-form">
          {error && <div className="auth-error">{error}</div>}

          <div className="form-group">
            <label>Senha</label>
            <input
              type="password"
              value={senha}
              onChange={(e) => setSenha(e.target.value)}
              placeholder="Mínimo 8 caracteres"
              required
              autoFocus
              disabled={!token}
            />
          </div>

          <div className="form-group">
            <label>Confirmar senha</label>
            <input
              type="password"
              value={confirmacao}
              onChange={(e) => setConfirmacao(e.target.value)}
              placeholder="Repita a senha"
              required
              disabled={!token}
            />
          </div>

          <button
            type="submit"
            className="auth-button"
            disabled={loading || !token}
          >
            {loading ? (<><span className="spinner"></span>Ativando...</>) : 'Ativar conta'}
          </button>
        </form>

        <div className="auth-footer">
          <button onClick={() => navigate('/login')} className="link-button">
            Já tem conta? Fazer login
          </button>
        </div>
      </div>
    </div>
  );
}

export default AcceptInvite;
